var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_5935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0869 5.16026C9.90356 4.97696 9.63115 4.93705 9.40905 5.04056L10.971 3.47863C11.6153 2.83427 12.6601 2.83427 13.3044 3.47863L14.5204 4.69458C15.1647 5.33894 15.1647 6.38367 14.5204 7.02803L12.9486 8.59976C13.06 8.37533 13.0223 8.09567 12.8353 7.9087L10.0869 5.16026ZM4.32476 10.1248L9.11863 5.33097C9.01513 5.55307 9.05503 5.82548 9.23834 6.00879L11.9868 8.75723C12.1737 8.9442 12.4534 8.98197 12.6778 8.87057L7.87484 13.6736C7.60974 13.9387 7.26226 14.1056 6.88962 14.1468L3.65723 14.5046C3.56169 14.5151 3.48101 14.4344 3.49165 14.3389L3.85164 11.1088C3.89312 10.7366 4.05996 10.3896 4.32476 10.1248Z",
    stroke: "#8F969C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_5935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(1.5 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b32f286bfffa09236697cb98d7ebf118.svg";
export { ForwardRef as ReactComponent };